import { jsx as _jsx } from "react/jsx-runtime";
/**
 * <SoftBody3D>: a MeshInstance3D that draws its rest mesh (ADR-0005), plus Godot's wireframe gizmo
 * for every node, faint while unselected (ADR-0056): the triangle edges of every surface, nothing
 * without a mesh (`soft_body_3d_gizmo_plugin.cpp:62-97`).
 */
import { useMemo } from 'react';
import { PluginGizmo } from '../../../../r3f/gizmo/PluginGizmo';
import { meshDebugLines } from '../../../../r3f/meshes/meshDebugLines';
import { MeshInstance3D } from '../../../3d/meshinstance3d/Component';
import { CollisionDebugLines } from '../../shared/CollisionDebugLines';
function Wireframe({ mesh }) {
    const positions = useMemo(() => meshDebugLines(mesh), [mesh]);
    return (_jsx(PluginGizmo, { drawnFor: "every-node", children: _jsx(CollisionDebugLines, { positions: positions }) }));
}
export function SoftBody3D({ node, children }) {
    return (_jsx(MeshInstance3D, { node: node, gizmo: (mesh) => _jsx(Wireframe, { mesh: mesh }), children: children }));
}
//# sourceMappingURL=Component.js.map